import {NgModule} from "@angular/core";
import {Route, RouterModule, Routes} from "@angular/router";
import {CnSubRoutes} from "./cn/cn.route";
import {CpSubRoutes} from "./cp/cp.route";


export function getRouters(): { name: string; routeMethod: () => Routes }[] {
    return [
        {name : "cn", routeMethod: CnSubRoutes },
        {name : "cp", routeMethod: CpSubRoutes },
    ];
}

function collectSubRoutes(): Route[] {
    const routes: Route[] = [];
    const crmRouters = getRouters();
    for (const router of crmRouters) {
        const subRoutes = router.routeMethod();
        if (subRoutes) {
            routes.push(...subRoutes);
        }
    }
    return routes;
}

const routes: Routes = [
    {
        path: '',
        children: collectSubRoutes(),
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)], // ✅ forChild for lazy module
    exports: [RouterModule],
})
export class FeatureProvRoutingModule {}
